import { Flex, Skeleton } from '@driftt/dds'
import React from 'react'

import { StyledCard } from './ConfigLoader.styles'

const ConfigLoader = () => {
  return (
    <Flex justifyContent="center" fullWidth fullHeight>
      <StyledCard css={{ maxWidth: '1024px' }}>
        <Flex
          direction="column"
          gap={3}
          justifyContent="space-between"
          fullHeight
          fullWidth
        >
          <Skeleton height="50px" isLoading />
          <Skeleton css={{ flexGrow: 1 }} isLoading />
          <Skeleton height="50px" isLoading />
        </Flex>
      </StyledCard>
    </Flex>
  )
}

export default ConfigLoader
